import React, {useEffect, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import {makeStyles} from "@material-ui/core/styles";
import MetasTabela from "./MetasTabela";
import MetaDialog from "./MetaDialog";
import type {iMeta} from "./index";



const useStyles = makeStyles(theme => ({

}));


const MetasMainView = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [dialogOpen, setDialogOpen] = useState(false);
    const [ registro, setRegistro] = useState({
        id: 0,
        descricao: '',
        ano: 0,
        mes: 0,
        diasUteis: 0,
        metaCategoriaId: 0,
        estabelecimentoId: 0,
        turno: 0,
        objetivo: 0
    });

    useEffect( () => {



    }, []);

    const cbOpenDialog = (b,rD) => {
        console.log("mainview.cbOpenDialog", b, rD)
        setRegistro(rD);
        setDialogOpen(b);
    }


    return (
        <React.Fragment>
            { dialogOpen && <MetaDialog isOpen={dialogOpen} cbDialog={cbOpenDialog} registro={registro} />}
                <MetasTabela openDialog={cbOpenDialog}/>
        </React.Fragment>
    )

}

export default MetasMainView;
